export const SET_DIGITALID = 'SET_DIGITALID';
export const SET_SCRESPONSE = 'SET_SCRESPONSE';
